<template>
  <bulk-update-wrapper
    :saving="saving"
    title="Unassign"
    :button-label="buttonLabel"
    :has-changes="true"
    @save="save"
    @dismiss="dismiss"
  >
    <vs-text> Ensure selected jobs are suitable to unassign</vs-text>

    <template #error-snackbar>
      <vs-snackbar :value="showSnackBar" type="error" sticky @input="clearSnackbar">
        Failed to unassign jobs
      </vs-snackbar>
    </template>
  </bulk-update-wrapper>
</template>

<script setup lang="ts">
import BulkUpdateWrapper from '../common/BulkUpdateWrapper.vue'
import { ref, computed } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { useBulkUnassignMutation } from '@/api/jobs'

const emits = defineEmits<{
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}>()

const props = defineProps<{
  selectedJobs: JobJson[]
}>()

const showSnackBar = ref(false)

const { bulkUnassign, isLoading: saving, isError } = useBulkUnassignMutation()

const dismiss = () => emits('dismiss')
const clearSnackbar = () => (showSnackBar.value = false)

const buttonLabel = computed<string>(() => {
  const jobCount = props.selectedJobs.length
  return jobCount >= 2 ? `Unassign ${jobCount} jobs` : 'Unassign job'
})

const save = async () => {
  try {
    await bulkUnassign({
      jobIds: props.selectedJobs.map((job) => job.id),
    })
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, {
        assigned_resource_id: null,
        assigned_service_provider_id: null,
      }),
    )
    emits('updated', { message: 'Jobs Unassigned', updatedJobs })
  } catch (e) {
    showSnackBar.value = isError.value
  }
}
</script>
